import { create } from 'zustand';

export const useShownResources = create(set => ({
  shownResources: [],
  setShownResources: shownResources => set(() => ({ shownResources }))
}));
